import React, { createContext, useContext, useState } from 'react';

const GenderMatchProbContext = createContext();

export const useGender = () => useContext(GenderMatchProbContext);

export const GenderMatchProbProvider = ({ children }) => {
  const [selectedGender, setSelectedGender] = useState('Men');

  return <GenderMatchProbContext.Provider value={{ selectedGender, setSelectedGender }}>{children}</GenderMatchProbContext.Provider>;
};
